import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SynchronizationConfiguration, SynchronizationTaskHistory} from '../synchronization.reducer';
import {SynchronizationFacadeService} from '../synchronization-facade.service';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-synchronization-task-history',
  template: `
      <ng-container *ngIf="histories$; else noHistories">
          <h3>
              Last invocation results from platform {{configuration.platform}}
          </h3>
          <div *ngIf="!(histories$ | async)?.length">
              No invocations yet.
          </div>
          <ng-container *ngFor="let history of histories$ | async">
              <mat-card>
                  <p class="sync-history-result">Result: <b>{{history.result}}</b></p>
                  <p *ngIf="history.resultError" class="sync-history-error">
                      Error encountered: <b>{{history.resultError}}</b>
                  </p>
                  <p class="sync-history-external-entities" [matTooltip]="externalEntitiesTooltipInfo"> Number of
                      entities
                      held by
                      external
                      platform: <b>{{history.numberOfExternalEntities}}</b></p>
                  <p class="sync-history-internal-entities" [matTooltip]="internalEntitiesTooltipInfo"> Number of
                      entities
                      matched
                      by
                      DMP: <b>{{history.numberOfInternalEntities}}</b></p>
                  <p *ngIf="history.additionalInfo"
                     class="sync-history-additional-info">Additional information: {{history.additionalInfo | json}}</p>
                  <p class="sync-history-performed-by" [matTooltip]="performedByTooltipInfo">Performed by:
                      <b>{{history.performedBy || 'SYSTEM'}}</b></p>
                  <p class="sync-history-performed-at">Performed at:
                      <b>{{history.performedAt.valueOf() * 1000 | date: 'dd/MM/yyyy HH:mm' }}</b>
                  </p>
              </mat-card>
          </ng-container>
      </ng-container>
      <ng-template #noHistories>
          <div>No invocations yet for this platform!</div>
      </ng-template>
  `,
  styleUrls: ['./synchronization-task-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SynchronizationTaskHistoryComponent {
  internalEntitiesTooltipInfo = `Number of segment shells that are shared to the platform. 
  If number of internal entities does not match the number of external entities, 
  it can mean that the state is desynchronized and synchronization didn't fix that. 
  It should be investigated by one of the DMP developers.`;
  externalEntitiesTooltipInfo = `Number indicating how many segments an external platform holds.`;
  performedByTooltipInfo = `SYSTEM means that the synchronization was performed automatically by scheduler.`;

  histories$?: Observable<SynchronizationTaskHistory[]>;
  configuration?: SynchronizationConfiguration;

  constructor(private facade: SynchronizationFacadeService) {
  }

  @Input() set selectedConfiguration(config: SynchronizationConfiguration) {
    this.configuration = config;
    if (config) {
      this.facade.loadTaskHistories(config.id);
      this.histories$ = this.facade.selectTaskHistories(config.id);
    }
  }

}
